export type RouteSeoItem = {
  pageName: string;
  description: string;
  isHome?: boolean;
};

export const SITE_BRAND_NAME = '듣고 배우는 한국어';
export const OG_URL_BASE = 'https://m.listenandlearnkorean.com';
export const CANONICAL_URL_BASE = 'https://www.listenandlearnkorean.com';
export const DEFAULT_CANONICAL_LIST_TYPE = 's';
export const DIALECT_REGION_NATIONWIDE = '전국';

export const CANONICAL_LIST_PATH_MAP: Record<string, string> = {
  '/word': '/word',
  '/example': '/example',
  '/saseung': '/saseung',
  '/sajaseungeo': '/sajaseungeo',
  '/proverb': '/proverb',
  '/movie-collect': '/movie-collect',
};

export const CANONICAL_HOME_PATHS = [
  '/movie-search',
  '/link',
];

export const APP_INTERNAL_QUERY_PARAMS = [
  'serial',
];

export const HOME_SEO: RouteSeoItem = {
  pageName: SITE_BRAND_NAME,
  description: '듣고 배우는 한국어 — 6만 여 한국어 어휘의 바른 뜻과 성조, 음가를 배워 보세요.',
  isHome: true,
};

export const DEFAULT_BOARD_SEO: RouteSeoItem = {
  pageName: '게시판',
  description: '듣고 배우는 한국어의 공지와 도움말을 볼 수 있습니다.',
};

export const BOARD_ROUTE_SEO_CONFIG: Record<string, RouteSeoItem> = {
  '1': {
    pageName: '운영자의 말',
    description: '사전 제작 취지와 한국어 표기, 발음, 성조에 관한 운영자의 안내를 볼 수 있습니다.',
  },
  '2': {
    pageName: '베풀기',
    description: '듣고 배우는 한국어의 사용법과 도움말, 보충 설명을 볼 수 있습니다.',
  },
};

export const ROUTE_SEO_CONFIG: Record<string, RouteSeoItem> = {
  '/': HOME_SEO,
  '/main': {
    pageName: '메인',
    description: '국어 사전, 옥편, 속담 사전, 사 자 성어 사전, 사투리 사전의 기능을 무료로 누릴 수 있습니다.',
  },
  '/word': {
    pageName: '단어와 예문',
    description: '궁금한 어휘를 빠르게 검색하고 고저장단이 적용된 녹음을 듣고 정확한 발음을 확인할 수 있습니다.',
  },
  '/example': {
    pageName: '문장 듣기',
    description: '예문을 검색하고 범주·조사별로 살펴보며 문장 속 높낮이와 장단을 들을 수 있습니다.',
  },
  '/saseung': {
    pageName: '사 성 옥편',
    description: '평성, 상성, 거성, 입성의 사성 체계 및 옥편의 기능을 활용할 수 있습니다.',
  },
  '/homonym': {
    pageName: '같은 글자, 다른 소리',
    description: '우리말에 많은 동음이의어를 듣고 비교하면서 빠르게 확인할 수 있습니다.',
  },
  '/sajaseungeo': {
    pageName: '사 자 성어',
    description: '약 1,800개 이상의 사 자 성어의 정확한 뜻과 발음, 실 사용의 예를 확인할 수 있습니다.',
  },
  '/dialect': {
    pageName: '모두 우리말',
    description: '각 지방의 흥미롭고 정겨운 사투리를 전국 9 군데로 나누어 표현과 뜻을 확인할 수 있습니다.',
  },
  '/proverb': {
    pageName: '속담',
    description: '속담을 재미있게 공부할 수 있습니다.',
  },
  '/movie-collect': {
    pageName: '동영상 모아 보기',
    description: '한국어 학습에 도움이 되는 동영상을 한곳에 모아 볼 수 있습니다.',
  },
  '/admin-msg': {
    pageName: '운영자의 말',
    description: '사전 제작 취지와 한국어 표기, 발음, 성조에 관한 운영자의 안내를 볼 수 있습니다.',
  },
};
